import { createRouter, createWebHistory } from "vue-router";
import { authGuard } from "@auth0/auth0-vue";

const CallbackView = () => import("@/views/CallbackView.vue");
const DashboardView = () => import("@/views/DashboardView.vue");
const NotFoundView = () => import("@/views/NotFoundView.vue");
const SuccessView = () => import("@/views/SuccessView.vue");
const CancelView = () => import("@/views/CancelView.vue");

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: DashboardView,
    beforeEnter: authGuard
  },
  {
    path: "/success",
    name: "Success",
    component: SuccessView,
    //beforeEnter: authGuard
  },
  {
    path: "/cancel",
    name: "Cancel",
    component: CancelView,
    //beforeEnter: authGuard
  },
  {
    path: "/callback",
    name: "callback",
    component: CallbackView,
  },
  {
    path: "/:catchAll(.*)",
    name: "Not Found",
    component: NotFoundView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;